import styled from 'styled-components';
import { breakpoints } from '../../styles/breakpoints';

const PlaybackStartingButtons = styled.div`
	display: flex;
	flex-direction: row;

	> button {
		margin-right: 5px;

		@media ${breakpoints.sm} {
			margin-right: 10px;
		}

		@media ${breakpoints.md} {
			margin-right: 15px;
		}

		&:last-child {
			margin-right: 0;
		}
	}
`;

export default PlaybackStartingButtons;
